import React from 'react';

import { ISocialIframeProps } from './social-embed';

const DEFAULT_WIDTH = '500';
const DEFAULT_HEIGHT = '800';

const FacebookIframe: React.FC<ISocialIframeProps> = ({ src, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT }) => (
  <iframe
    src={src}
    width={width}
    height={height}
    style={{ border: 'none', overflow: 'hidden' }}
    scrolling="no"
    frameBorder="0"
    allowFullScreen
    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
  />
);

export default FacebookIframe;
